import { Injectable } from '@angular/core';
 import { Observable } from 'rxjs/Observable';
//  import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
//  import { catchError, retry } from 'rxjs/operators';
 import 'rxjs/add/operator/map';
 import { IEmployeesCountRangeMOdel, IIndustriesModel, ILanguageModel, IRegionModel, ICategory,
   IPostProdProcesses, IQuantityUnit, ICountryViewModel,
   ICertificationViewModel, IIndustryBranchesModel, SupplierTypeViewModel, EmployeesCountRangeViewModel} from '../../models/globalMaster';

import { DataService } from '../data.service';
import { IPartLibraryModel } from '../../models/partModel';
import { IIndividualList, IManufacturersViewModel, ITerritoryClassificationModel, RfqQuality } from '../../models/rfqModel';
import { IToleranceViewModel } from '../../models/supplierProfileModel';
import { SourcingAdvisors, AccountType, CustomerSupportRepresentatives } from '../../models/actionTrackerModel';


@Injectable()
export class MasterService {


  moduleUrl: string;

  constructor(private _dataService: DataService) { }



  getIndustryType(): Observable<IIndustriesModel[]> {
    this.moduleUrl = 'Master/GetIndustryType';
    return this._dataService.getAll(this.moduleUrl);
  }

  getLanguages(): Observable<ILanguageModel[]> {
    this.moduleUrl = 'Master/GetLanguages';
    return this._dataService.getAll(this.moduleUrl);
  }

  getEmployeesCountRange(): Observable<IEmployeesCountRangeMOdel[]> {
    this.moduleUrl = 'Master/GetEmployeesCountRange';
    return this._dataService.getAll(this.moduleUrl);
  }

  getState(countryId: string): Observable<IRegionModel[]> {
    this.moduleUrl = 'Master/GetState?CountryId=' + countryId + '';
    return this._dataService.getAll(this.moduleUrl);
  }
  getQuantityUnit(): Observable<IQuantityUnit[]> {
    this.moduleUrl = 'Master/GetQuantityUnit';
    return this._dataService.getAll(this.moduleUrl);
  }
  getCategory(): Observable<ICategory[]> {
    this.moduleUrl = 'Master/GetCategory';
    return this._dataService.getAll(this.moduleUrl);
  }
  getPartLibrary(contactId: number, searchText: string): Observable<IPartLibraryModel[]> {
    this.moduleUrl = 'RFQ/GetPartsList?ContactId=' + contactId;
    if (searchText !== '') {
      this.moduleUrl += '&SearchText=' + searchText;
    }
    return this._dataService.getAll(this.moduleUrl);
  }
  getPostProdProcesses(): Observable<IPostProdProcesses[]> {
    this.moduleUrl = 'Master/GetPostProdProcesses';
    return this._dataService.getAll(this.moduleUrl);
  }
  getCountry(): Observable<ICountryViewModel[]> {
    this.moduleUrl = 'Master/GetCountries';
    return this._dataService.getAll(this.moduleUrl);
  }
  GetTerritoryClassification(): Observable<ITerritoryClassificationModel[]> {
    this.moduleUrl = 'Master/GetTerritoryClassification';
    return this._dataService.getAll(this.moduleUrl);
  }



  getCertificate(companyId: number): Observable<ICertificationViewModel[]> {
    if (companyId === null) {
      this.moduleUrl = 'Master/SpecialCertificateList';
    } else {
      this.moduleUrl = 'Master/SpecialCertificateList?CompanyId=' + companyId;
    }
    return this._dataService.getAll(this.moduleUrl);
  }


  GetIndustryBranches(): Observable<IIndustryBranchesModel[]> {
    this.moduleUrl = 'Master/GetIndustryBranches';
    return this._dataService.getAll(this.moduleUrl);
  }

  getCompanyTypes(): Observable<SupplierTypeViewModel[]> {
    this.moduleUrl = 'Master/GetAllCompanyTypes';
    return this._dataService.getAll(this.moduleUrl);
  }

  getEmployeeRange(): Observable<EmployeesCountRangeViewModel[]> {
    this.moduleUrl = 'Master/GetEmployeesCountRange';
    return this._dataService.getAll(this.moduleUrl);
  }

  getSupplierList(searchText: string): Observable<IIndividualList[]> {
    if (searchText !== '' || searchText !== undefined) {
      this.moduleUrl = 'RFQ/GetIndividual?searchParam=' + searchText;
    } else {
      this.moduleUrl = 'RFQ/GetIndividual';
    }
    return this._dataService.getAll(this.moduleUrl);
  }
  getManuGroupList(searchText: string): Observable<IManufacturersViewModel[]> {
    if (searchText !== '' || searchText !== undefined) {
      this.moduleUrl = 'RFQ/GetGroups?searchParam=' + searchText;
    } else {
      this.moduleUrl = 'RFQ/GetGroups';
    }
    return this._dataService.getAll(this.moduleUrl);
  }

  getTolerance(): Observable<IToleranceViewModel[]> {
    this.moduleUrl = 'Master/GetTolerance';
    return this._dataService.getAll(this.moduleUrl);
  }
  getRfqQuality(): Observable<RfqQuality[]> {
    this.moduleUrl = 'Master/GetRfqQuality';
    return this._dataService.getAll(this.moduleUrl);
  }

  getSourcingAdvisorsList(IsBuyer:boolean): Observable<SourcingAdvisors[]> {
    this.moduleUrl = 'Master/GetSourcingAdvisorsList?IsBuyer='+IsBuyer;
    return this._dataService.getAll(this.moduleUrl);
  }
  getAccountTypeList (): Observable<AccountType[]> {
    this.moduleUrl = 'Master/GetAccountTypeList ';
    return this._dataService.getAll(this.moduleUrl);
  }
  getCustomerSupportRepresentativesList(): Observable<CustomerSupportRepresentatives[]> {
    this.moduleUrl = 'Master/GetAllCustomerSupportRepresentatives';
    return this._dataService.getAll(this.moduleUrl);
  }
  GetCompanyTypesForBuyers(): Observable<IIndustryBranchesModel[]> {
    this.moduleUrl = 'Master/GetCompanyTypesForBuyers';
    return this._dataService.getAll(this.moduleUrl);
  }
  getTrackerManufacturerList(rfqId:number,status:string, searchText:string): Observable<any>{
    this.moduleUrl ='RFQTrackerManufacturerDrawer?rfqId='+rfqId+'&type='+status+'&searchText='+searchText;
    return this._dataService.getAll(this.moduleUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/master/master.service.ts